import React, { Component, PropTypes } from 'react';
import gql from 'graphql-tag';

// Import the CSS
import '../../scss/components/_builder.scss';

export default class Builder extends Component {
	handleClick = e => {
		this.props.onClick(e, this.props.builder);
	};

	renderLogo = () => {
		const { brandLogoSmall, brandLogoMed } = this.props.builder;

		if (brandLogoSmall) {
			return <img src={brandLogoSmall} />;
		} else if (brandLogoMed) {
			return <img src={brandLogoMed} />;
		} else {
			return <div className="logo-placeholder">Logo</div>;
		}
	};

	render() {
		const { builder } = this.props;
		const { id, name, number, subdivisionCounts, sourceFeed } = builder;

		return (
			<div className="row table-row builder" onClick={this.handleClick} key={id}>
				<div className="logo-cell table-cell">{this.renderLogo()}</div>
				<div className="cell cell-third table-cell">
					<div>
						<div className="title">{name}</div>
						<div className="sub-title">#{number}</div>
					</div>
				</div>
				<div className="cell table-cell">
					<div className="row row-wrap">
						<div className="row">
							<div className="stat-title cell">Communities</div>
							<div className="stat cell">{subdivisionCounts.total}</div>
						</div>
						<div className="row">
							<div className="stat-title cell">Communities Paid</div>
							<div className="stat cell">
								{subdivisionCounts.enabled}/{subdivisionCounts.active}
							</div>
						</div>
						<div className="row">
							<div className="stat-title cell cell-align-top">Feed Source</div>
							<div className="stat feed-source-value cell">
								{sourceFeed && sourceFeed.source
									? sourceFeed.source
									: 'Unavailable'}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

Builder.fragments = {
	builder: gql`
		fragment BuilderResults on BuilderCollection {
			results {
				id
				rawId: id(raw: true)
				name
				number
				brandLogoSmall
				brandLogoMed
				subdivisionCounts {
					total
					active
					enabled
				}
				sourceFeed {
					source
				}
			}
			numTotal
		}
	`,
};

Builder.propTypes = {
	builder: PropTypes.object.isRequired,
	onClick: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/assets/js/components/Builder.js